import { gql } from "graphql-request";
export const CHART_FIELDS = gql`
    fragment ChartFields on Chart {
        id
        name
        promotions {
            ...PromotionFields
        }
    }
`;